//stop native BS functionality of closing menu in order to support in-dropdown clicks
$('.dropdown-menu.multiselect-menu').on("click.bs.dropdown", function (e) {
    e.stopPropagation();

    //e.preventDefault();
}); 

$('[data-close-dropdown-trigger]').on('click', function () {
    $(this).closest('.dropdown-container').find('.dropdown-toggle').dropdown('hide');
});


function markDropdownLabels(context, query) {
    var instance = new Mark(context);

    // Remove previous marked elements and mark the new keyword inside the context
    instance.unmark({
        done: function () {
            instance.mark(query);
        }
    });
};

$('[data-dropdown-search]').on('input', function () {
    var dropdownContainer = $(this).closest('.dropdown-container');
    var dropdownMenu = $(dropdownContainer).find('.dropdown-menu');
    var noResultsItem = $(dropdownMenu).find('.dropdown-no-results');

    //display dropdown if hidden
    if (dropdownMenu.is(":hidden")) {
        dropdownContainer.find('.dropdown-toggle').dropdown('toggle');
    }

    var search = $(this).val().toLowerCase();

    var dropdownItemContainerClassSelector = '.dropdown-item-container';
    var dropdownItemTextSelector = '[data-dropdown-item-text]';

    if (!search) {
        dropdownMenu.find(dropdownItemContainerClassSelector).show();
    }

    //highlight (using markjs, requires a vanilla JS node collection)
    markDropdownLabels($(dropdownMenu).find(dropdownItemTextSelector).get(), search);

    var foundResults = false;

    //show/hide
    dropdownMenu.find(dropdownItemTextSelector).each(function () {
        //var text = $(this).contents().filter(function () {
        //    return this.nodeType == Node.TEXT_NODE;
        //})[0].nodeValue.toLowerCase();

        var text = $(this).text().toLowerCase();

        var dropdownItem = $(this).closest(dropdownItemContainerClassSelector);

        if (text.indexOf(search) > -1) {
            $(noResultsItem).hide();
            dropdownItem.show();
            foundResults = true;
        }
        else {
            dropdownItem.hide();
        }
    });

    if (!foundResults) {
        $(noResultsItem).find("span").text(String.format('"{0}"', $(this).val()));
        $(noResultsItem).show();
    }
});